import { ON_LOAD } from '../state-constants/stateConstants';

export const onLoadAction = (status) => ({
    type: ON_LOAD,
    payload: status,
});



// WEBPACK FOOTER //
// ./src/state-actions/onLoadAction.js